<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true">
      <template slot="actions">
        <vs-button color="success" type="filled" icon-pack="feather" icon="icon-eye" @click="transferHistoryPopup">{{ $t('show_history') }}</vs-button>
      </template>

      <vs-divider></vs-divider>
    </vx-card>

    <vx-card id="transfersDataContainer" :title="$tc('transfer', 2)" class="mb-8 vs-con-loading__container">
      <shared-transfers-list
        :transferNumbers="transferNumbers"
        @unTransfer="unTransfer"
        @transfer="transfer"
        @edit="editTransferPopup"
      ></shared-transfers-list>
    </vx-card>

    <modal :title="$t('edit_transfer')" :active.sync="modals.edit" size="md">
      <div id="EditTransferFormContainer" class="vs-con-loading__container">
        <shared-transfers-edit
          @editTransferSuccess="editTransferSuccess"
        ></shared-transfers-edit>

        <vs-divider></vs-divider>

        <div class="flex justify-end">
          <vs-button id="editTransferButton" color="primary" type="filled" @click.prevent="updateTransfer">{{ $t('save') }}</vs-button>
        </div>
      </div>
    </modal>

    <modal :title="$t('history')" :active.sync="modals.history" size="xl">
      <shared-transfers-history
        :transferLogs="transferLogs"
      ></shared-transfers-history>
    </modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal'
import Transfer from '@/models/Transfer'
import TransferLog from '@/models/TransferLog'
import Utils from '@/helpers/utils'
import { EventBus } from '@/../eventbus'
import SharedTransfersList from '@/views/Shared/Transfers/List'
import SharedTransfersHistory from '@/views/Shared/Transfers/History'
import SharedTransfersEdit from '@/views/Shared/Transfers/Edit'

export default {
  name: 'User.Transfers',
  components: {
    Modal,
    SharedTransfersList,
    SharedTransfersHistory,
    SharedTransfersEdit
  },
  data () {
    return {
      transferNumbers: {},
      transferLogs: {},
      modals: {
        edit: false,
        history: false
      }
    }
  },
  watch: {
    'modals.edit' (val) {
      if (!val) {
        EventBus.$emit('initTransferResetFormData')
      }
    }
  },
  mounted () {
    this.initData()
    this.$windowOpenerHelper.listenToPopUpMessage('reload_transfers_table', this.initData)
  },
  methods: {
    async initData () {
      this.$store.dispatch('setIsMainTableLoading', true)
      try {
        const response = await Transfer.findAll()
        this.transferNumbers = response.data.transfers
      } catch (e) {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
      }
      this.$store.dispatch('setIsMainTableLoading', false)
    },
    async transferHistoryModal () {
      const response = await TransferLog.history()
      this.transferLogs = response.data.data
      this.modals.history = true
    },
    transferHistoryPopup () {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'transfer-history', {}, this.transferHistoryModal)
    },
    async transfer (id) {
      try {
        const response = await Transfer.transfer({ id })

        this.$swalHelper.success({
          title: this.$t('action_success'),
          text: this.$t(response.data),
          confirmButton: this.$t('confirm')
        })

        this.initData()
      } catch (e) {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
      }
    },
    async unTransfer (id) {
      try {
        const response = await Transfer.unTransfer({ id })

        this.$swalHelper.success({
          title: this.$t('action_success'),
          text: this.$t(response.data),
          confirmButton: this.$t('confirm')
        })

        this.initData()
      } catch (e) {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
      }
    },
    updateTransfer () {
      EventBus.$emit('initUpdateTransfer')
    },
    editTransferModal (id) {
      this.modals.edit = true
      EventBus.$emit('initTransferGetFormData', {id})
    },
    editTransferPopup (id) {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'edit-transfer', {id}, this.editTransferModal)
    },
    editTransferSuccess () {
      this.initData()
      this.modals.edit = false
    }
  }
}
</script>

<style scoped>

</style>
